import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HomepageMapControlsComponent } from '../map-controls/homepage-map-controls.component';
import { AutoAnimateDirective } from '@planmeister/pithos';
import { ModalService } from '../../../../core/services/modal.service';
import { DownloadAppModalComponent } from '../download-app-modal/download-app-modal.component';
import { CompanyOnboardingService } from '../../../../company/onboarding/company-onboarding.service';

@Component({
    selector: 'home-hero-section',
    imports: [
        RouterLink,
        HomepageMapControlsComponent,
        AutoAnimateDirective
    ],
    templateUrl: './home-page-hero-section.component.html'
})
export class HomePageHeroSectionComponent {
    private readonly modalService = inject(ModalService);
    private readonly onboardingService = inject(CompanyOnboardingService);

    protected openDownloadModal(): void {
        const modalId = this.modalService.open({
            component: DownloadAppModalComponent,
            inputs: {
            },
            outputs:{
                closeModal: () => this.modalService.close(modalId)
            }
        });
    }

    protected openOnboarding(): void {
        this.onboardingService.start();
    }
}
